import { type ISection } from './components/SurveyFeatureStepper/types'
import { MULTIPLE_CHOICE_SEPERATOR } from './components/SurveyFeatureStepper/utils'

/**
 * Updates the local state draft with the latest response items.
 * The itemId acts as the key for the value in the draft.
 */
export const updateLocalDraft = (itemId: string, value: string | string[], draftKey: string): void => {
  const currDraft = JSON.parse(localStorage.getItem(draftKey) ?? '{}')

  // if value is blank, remove the item from the draft
  const isValueEmpty = value === '' || (Array.isArray(value) && value.length === 0)
  let updatedDraft
  if (isValueEmpty) {
    const { [itemId]: _, ...rest } = currDraft
    updatedDraft = rest
  } else {
    updatedDraft = { ...currDraft, [itemId]: value }
  }

  // if updatedDraft is empty, remove the draft from localStorage
  if (Object.keys(updatedDraft).length === 0) {
    localStorage.removeItem(draftKey)
  } else {
    localStorage.setItem(draftKey, JSON.stringify(updatedDraft))
  }
}

/**
 * Updates the responses for the sections based on the local draft.
 */
export const getResponsesFromDraft = (sections: ISection[], draftKey: string): ISection[] => {
  const localDraft = JSON.parse(localStorage.getItem(draftKey) ?? '{}')

  return sections.map(section => {
    const updatedItems = section.surveyItems.map(item => {
      const name = `${item.itemId}${section.instructorId ? section.instructorId : ''}`
      const savedValue = localDraft[name]

      const valueStr = Array.isArray(savedValue) ? savedValue.join(MULTIPLE_CHOICE_SEPERATOR) : savedValue ?? ''
      return { ...item, value: valueStr }
    })
    return { ...section, surveyItems: updatedItems, children: getResponsesFromDraft(section.children, draftKey) }
  })
}
